;(function(){

	var defaults = {
			active: 640
		},
		count = 0;

	$.fn.equalHeight = function(method, settings){

		var instanceOptions = $.extend({}, defaults, settings);

		this.each(function(){

			var $eh = $(this);

			var options = $.extend({}, instanceOptions, $eh.data());

			$eh = {
				root: $eh,
				container: $eh.parents('.container'),
				children: $eh.find('.equal-height__component')
			};

			var eh = {
				height: false
			};

			site.resize['equalHeight-' + count] = function(){

				eh.height = 0;

				$eh.children
					.attr('style', null);

				if( $eh.container.outerWidth() >= options.active ){

					$eh.children
						.each(function(){

							var $this = $(this);

							eh.height = $this.outerHeight() > eh.height ? $this.outerHeight() : eh.height;

						});

					$eh.children
						.css({
							minHeight: eh.height
						})
						.addClass('is-equal');

				}

			};

			site.resize['equalHeight-' + count]();

			count++;

		});

		return this;

	};

	// trigger when all images and iframes within equal cols are loaded
	var $equalHeight = $('.equal-height');

	$equalHeight
		.each(function(){

			var $this = $(this);

			$this.imagesLoaded(function() {
				$this.equalHeight();
			});

		});

}());
